"use client";

import type { ReactNode } from "react";
import { track } from "@vercel/analytics";

import { Link } from "@/i18n/navigation";

type AnalyticsValue = string | number | boolean;

export default function PublicSiteTrackedLink({
  analytics,
  additionalEventName,
  children,
  className,
  eventName,
  href,
}: Readonly<{
  analytics: Readonly<Record<string, AnalyticsValue>>;
  additionalEventName?: string;
  children: ReactNode;
  className?: string;
  eventName: string;
  href: string;
}>) {
  return (
    <Link
      className={className}
      href={href}
      onClick={() => {
        track(eventName, analytics);
        if (additionalEventName) {
          track(additionalEventName, analytics);
        }
      }}
    >
      {children}
    </Link>
  );
}
